import request from '@/utils/request'

export function getList(parmas) {
    return request({
        url: 'api/task?alias=' + parmas,
        method: 'get'
    })
}

export function add(data) {
    return request({
        url: 'api/task',
        method: 'post',
        data
    })
}

export function del(id) {
    return request({
        url: 'api/task/' + id,
        method: 'delete'
    })
}

export function del2(id) {
    return request({
        url: 'api/taskNormal/' + id,
        method: 'delete'
    })
}

export function edit(data) {
    return request({
        url: 'api/task',
        method: 'put',
        data
    })
}

export function getVedio(query) {
    return request({
        url: 'api/video?' + query,
        method: 'get'
    })
}

export function getAudio(query) {
    return request({
        url: 'api/audio?' + query,
        method: 'get'
    })
}

export function postInsertTask(data) {
    return request({
        url: 'api/insertTask',
        method: 'post',
        data
    })
}
export function postAutomaticRowTable(id, data) {//自动安排任务
    return request({
        url: `api/automaticRowTable/` + id,
        method: 'post',
        data
    })
}